interface LicenseStatusCount {
  expired: number;
  inProcess: number;
  current: number;
  archived: number;
}

interface ActionStatusCount {
  notStarted: number;
  expired: number;
  inProcess: number;
  current: number;
}

export const transformLicensesToChartData = (localLicenses: any, currentFilters: any, locationMapping: any[]) => {
  const result: { [key: string]: LicenseStatusCount } = {};
  const selectedStatuses = currentFilters.statusLicanse.selected;

  const locationMappingObject: { [key: string]: string } = {};
  locationMapping.forEach((location) => {
    locationMappingObject[location.Title] = location.Code;
  });

  locationMapping.forEach((location) => {
    result[location.Code] = {
      expired: 0,
      inProcess: 0,
      current: 0,
      archived: 0,
    };
  });

  localLicenses.forEach((license: any) => {
    if (!selectedStatuses.includes(license.status.name)) {
      return;
    }

    const locationName = license.location?.name;
    if (!locationName) return;

    const locationCode = locationMappingObject[locationName];
    if (!locationCode) return;

    if (license.status.name === 'Просрочен') {
      result[locationCode].expired += 1;
    } else if (license.status.name === 'В процессе') {
      result[locationCode].inProcess += 1;
    } else if (license.status.name === 'Действующий') {
      result[locationCode].current += 1;
    } else if (license.status.name === 'В архиве') {
      result[locationCode].archived += 1;
    }
  });

  return result;
};

// export const transformActionsToChartData = (localLicenses: any, currentFilters: any, locationMapping: any[]) => {
//   const result: { [key: string]: ActionStatusCount } = {};
//   const selectedStatuses = currentFilters.statusLicanse.selected;

//   const locationMappingObject: { [key: string]: string } = {};
//   locationMapping.forEach((location) => {
//     locationMappingObject[location.Title] = location.Code;
//   });

//   locationMapping.forEach((location) => {
//     result[location.Code] = {
//       notStarted: 0,
//       expired: 0,
//       inProcess: 0,
//       current: 0,
//     };
//   });

//   localLicenses.forEach((license: any) => {
//     if (!selectedStatuses.includes(license.status.name)) {
//       return;
//     }

//     const locationName = license.location?.name;
//     if (!locationName) return;

//     const locationCode = locationMappingObject[locationName];
//     if (!locationCode) return;

//     if (license.actionStatus === 'Не начато') {
//       result[locationCode].notStarted += 1;
//     } else if (license.actionStatus === 'Просрочено') {
//       result[locationCode].expired += 1;
//     } else if (license.actionStatus === 'В процессе') {
//       result[locationCode].inProcess += 1;
//     } else if (license.actionStatus === 'Закрыто') {
//       result[locationCode].current += 1;
//     }
//   });

//   return result;
// };


export const transformActionsToChartData = (localLicenses: any, currentFilters: any, locationMapping: any[]) => {
  const result: { [key: string]: ActionStatusCount } = {};
  const selectedStatuses = currentFilters.statusLicanse.selected;

  const locationMappingObject: { [key: string]: string } = {};
  locationMapping.forEach((location) => {
    locationMappingObject[location.Title] = location.Code;
  });

  locationMapping.forEach((location) => {
    result[location.Code] = {
      notStarted: 0,
      expired: 0,
      inProcess: 0,
      current: 0,
    };
  });

  localLicenses.forEach((license: any) => {
    if (!selectedStatuses.includes(license.status.name)) {
      return;
    }

    const locationName = license.location?.name;
    if (!locationName) return;

    const locationCode = locationMappingObject[locationName];
    if (!locationCode) return;
    license.actions.forEach((action: any) => {
      const status = action.statusAction?.ID || action.statusAction?.$1q_1;
      
      if (status === 227) {
        result[locationCode].notStarted += 1;
      } else if (status === 229) {
        result[locationCode].expired += 1;
      } else if (status === 231 || status === 230) {
        result[locationCode].current += 1;
      } else {
        result[locationCode].inProcess += 1;
      }
    });
  });

  return result;
};